<div class="n-oldalfej">
  <div>
    <h2>Alkalmazottak</h2>
    <span class="n-alcim">{{ aktiv.ugyfelNev || 'nincs kiválasztott ügyfél' }}</span>
  </div>
  <div class="spacer"></div>
  <ion-button fill="outline" style="--color:#fff;--border-color:rgba(255,255,255,.6)" (click)="ujAlkUgyfelbol()" [disabled]="!aktiv.ugyfelId" title="Az ügyfél adataiból (pl. egyéni vállalkozó saját maga)">
    <ion-icon slot="start" name="copy-outline"></ion-icon>Ügyfél átmásolása
  </ion-button>
  <ion-button *ngIf="aktiv.sulinform" fill="outline" style="--color:#fff;--border-color:rgba(255,255,255,.6)" (click)="nyitSulinform()" title="A kötött SULINFORM-intézmény munkatársainak importja / összekötése (jelenlét-átvételhez)">
    <ion-icon slot="start" name="school-outline"></ion-icon>SULINFORM munkatársak
  </ion-button>
  <ion-button fill="outline" style="--color:#fff;--border-color:rgba(255,255,255,.6)" (click)="nyitNavImport()" [disabled]="!aktiv.ugyfelId" title="A NAV-hoz bejelentett foglalkoztatottak importálása (a kapcsolt NAPLO-ügyfél M2M-lekérdezéséből)">
    <ion-icon slot="start" name="cloud-download-outline"></ion-icon>NAV bejelentettek
  </ion-button>
  <ion-button fill="outline" style="--color:#fff;--border-color:rgba(255,255,255,.6)" (click)="bejelentes()" [disabled]="bejelentFut || !aktiv.ugyfelId"
              title="Be- és kilépések bejelentése a NAV-hoz (T1041) – a kitöltőben ellenőrizhető és beküldhető">
    <ion-icon slot="start" name="paper-plane-outline"></ion-icon>{{ bejelentFut ? 'Előkészítés…' : 'Bejelentés (T1041)' }}
  </ion-button>
  <ion-button (click)="ujAlk()" [disabled]="!aktiv.ugyfelId"><ion-icon slot="start" name="person-add-outline"></ion-icon>Új alkalmazott</ion-button>
</div>

<div class="ures" *ngIf="!aktiv.ugyfelId"><ion-icon name="business-outline"></ion-icon>Válassz ügyfelet (Törzsadatok → Ügyfelek).</div>

<div class="alk-racs" *ngIf="aktiv.ugyfelId">
  <!-- Alkalmazottak -->
  <div class="n-panel alk-lista">
    <div class="n-panel-cim">Alkalmazottak ({{ alkalmazottak.length }})</div>
    <table class="n-racs" *ngIf="alkalmazottak.length">
      <thead><tr><th>Név</th><th>Adóazonosító</th><th class="num">Aktív jv.</th><th></th></tr></thead>
      <tbody>
        <tr *ngFor="let a of alkalmazottak" [class.kijelolt]="kivalasztott?.id === a.id" [class.rendezett]="a.inaktiv" (click)="valaszt(a)">
          <td><b>{{ a.nev }}</b> <span class="cimke" *ngIf="a.allomany_adid" title="SULINFORM-munkatárshoz kötve – a jelenlét onnan jön">SULINFORM</span></td><td>{{ a.adoazonosito || '—' }}</td><td class="num">{{ a.aktiv_jogviszony }}</td>
          <td class="ber-muv" (click)="$event.stopPropagation()">
            <button type="button" class="kv-mini" (click)="szerkAlk(a)" title="Adatok"><ion-icon name="create-outline"></ion-icon></button>
            <button type="button" class="kv-torol" (click)="torolAlk(a)" title="Törlés"><ion-icon name="trash-outline"></ion-icon></button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="ures" *ngIf="!alkalmazottak.length"><ion-icon name="people-outline"></ion-icon>Nincs még alkalmazott.</div>
  </div>

  <!-- A kiválasztott alkalmazott -->
  <div class="alk-reszlet" *ngIf="kivalasztott">
    <div class="n-panel">
      <div class="alk-panel-fej"><div class="n-panel-cim">Jogviszonyok – {{ kivalasztott.nev }}</div>
        <button type="button" class="ov-gomb" (click)="ujJv()"><ion-icon name="add"></ion-icon>Új jogviszony</button></div>
      <table class="n-racs" *ngIf="jogviszonyok.length">
        <thead><tr><th>Típus</th><th>Munkakör</th><th>Bér</th><th class="num">Óra/hét</th><th></th></tr></thead>
        <tbody>
          <tr *ngFor="let j of jogviszonyok" [class.rendezett]="!j.aktiv">
            <td>{{ cimke(opt.jogviszonyTipus, j.jogviszony_tipus) }} <span class="cimke" *ngIf="j.jogviszony_tipus === 'megbizas' && +j.tartos_megbizas">tartós</span> <span class="cimke" *ngIf="!j.aktiv">lezárt</span></td>
            <td>{{ j.munkakor || '—' }}<span class="halvany" *ngIf="munkaszamNev(j.munkaszam_id)"> · {{ munkaszamNev(j.munkaszam_id) }}</span></td>
            <td>{{ cimke(opt.berTipus, j.ber_tipus) }}: <b>{{ j.alapber | number:'1.0-0' }} Ft</b></td>
            <td class="num">{{ j.heti_oraszam }}</td>
            <td class="ber-muv"><button type="button" class="kv-mini" (click)="szerkJv(j)"><ion-icon name="create-outline"></ion-icon></button>
              <button type="button" class="kv-torol" (click)="torolJv(j)"><ion-icon name="trash-outline"></ion-icon></button></td>
          </tr>
        </tbody>
      </table>
      <p class="halvany" *ngIf="!jogviszonyok.length">Nincs jogviszony.</p>
    </div>

    <div class="n-panel">
      <div class="alk-panel-fej"><div class="n-panel-cim">Adó- és járulékkedvezmények</div>
        <button type="button" class="ov-gomb" (click)="ujKedv()"><ion-icon name="add"></ion-icon>Új kedvezmény</button></div>
      <table class="n-racs" *ngIf="kedvezmenyek.length">
        <tbody>
          <tr *ngFor="let k of kedvezmenyek">
            <td><b>{{ cimke(opt.kedvezmenyTipus, k.tipus) }}</b></td>
            <td><span *ngIf="k.tipus === 'csaladi'">{{ k.eltartottak }} eltartott / {{ k.kedvezmenyezett }} kedvezményezett · {{ k.megoszt_szazalek }}%</span></td>
            <td class="ber-muv"><button type="button" class="kv-mini" (click)="szerkKedv(k)"><ion-icon name="create-outline"></ion-icon></button>
              <button type="button" class="kv-torol" (click)="torolKedv(k)"><ion-icon name="trash-outline"></ion-icon></button></td>
          </tr>
        </tbody>
      </table>
      <p class="halvany" *ngIf="!kedvezmenyek.length">Nincs kedvezmény.</p>
    </div>

    <!-- Munkáltatói (szocho) kedvezmények – enélkül a számfejtés mindig a teljes 13%-ot számolja -->
    <div class="n-panel">
      <div class="alk-panel-fej"><div class="n-panel-cim">Munkáltatói kedvezmények (szocho)</div>
        <button type="button" class="ov-gomb" (click)="ujSzocho()"><ion-icon name="add"></ion-icon>Új szocho-kedvezmény</button></div>
      <p class="halvany alk-sugo">A szociális hozzájárulási adóból érvényesíthető kedvezmények (Szocho tv.).
        Egy hónapban egy kedvezmény jár ugyanarra a személyre – a számfejtés a legnagyobbat érvényesíti.
        A törvényi lépcsőket (pl. első év 100%, utána a minimálbér feléig) külön időszakként vedd fel.</p>
      <table class="n-racs" *ngIf="szochoKedvezmenyek.length">
        <tbody>
          <tr *ngFor="let k of szochoKedvezmenyek">
            <td><b>{{ cimke(opt.szochoKedvezmenyTipus, k.tipus) }}</b></td>
            <td>{{ cimke(opt.szochoAlapKorlat, k.alap_korlat) }}<span *ngIf="k.alap_korlat === 'osszeg'"> ({{ k.korlat_osszeg | number:'1.0-0' }} Ft)</span> · {{ k.szazalek }}%</td>
            <td class="halvany">{{ k.ervenyes_tol ? (k.ervenyes_tol | date:'yyyy.MM.dd') : '' }}<span *ngIf="k.ervenyes_tol || k.ervenyes_ig"> – </span>{{ k.ervenyes_ig ? (k.ervenyes_ig | date:'yyyy.MM.dd') : '' }}</td>
            <td class="ber-muv"><button type="button" class="kv-mini" (click)="szerkSzocho(k)"><ion-icon name="create-outline"></ion-icon></button>
              <button type="button" class="kv-torol" (click)="torolSzocho(k)"><ion-icon name="trash-outline"></ion-icon></button></td>
          </tr>
        </tbody>
      </table>
      <p class="halvany" *ngIf="!szochoKedvezmenyek.length">Nincs szocho-kedvezmény – a számfejtés a teljes adót számolja.</p>
    </div>

    <!-- SZABADSÁG: éves keret fajtánként (Mt. szerint automatikus, kézzel felülírható), felhasználás a jelenlétből -->
    <div class="n-panel">
      <div class="alk-panel-fej"><div class="n-panel-cim">Szabadság – {{ aktiv.ev }}</div>
        <button type="button" class="ov-gomb fo" *ngIf="szabadsag" [disabled]="szabMentes" (click)="szabadsagMent()"><ion-icon name="save-outline"></ion-icon>Mentés</button></div>
      <ng-container *ngIf="szabadsag; else nincsSzab">
        <p class="halvany alk-sugo">Napokban. Az üres mező a Munka Törvénykönyve szerinti érték (halványan látszik): alapszabadság 20 nap
          + életkor szerinti pótszabadság ({{ szabadsag.kor != null ? szabadsag.kor + ' éves az évben' : 'nincs születési idő' }}),
          gyermekek után ({{ szabadsag.gyermekek_16_alatt }} gyermek 16 év alatt), betegszabadság 15 nap; év közbeni munkaviszonynál arányosan
          ({{ szabadsag.jogviszony.arany < 1 ? (szabadsag.jogviszony.arany * 100 | number:'1.0-1') + '%' : 'egész év' }}). Az előző évi a tavalyi maradék.
          A felhasznált napok a jelenlétből jönnek (napi {{ szabadsag.napi_ora | number:'1.0-1' }} óra).</p>
        <div class="tabla-wrap">
          <table class="n-racs alk-szab">
            <thead><tr><th>Fajta</th><th class="num">Előző évi</th><th class="num">Adott évi</th><th class="num">E. felh.</th><th class="num">Kiadható</th><th class="num">Össz.</th></tr></thead>
            <tbody>
              <tr *ngFor="let s of szabadsag.sorok">
                <td>{{ s.cim }}</td>
                <td class="num"><input *ngIf="s.fajta === 'alap'" type="number" step="0.5" min="0" [(ngModel)]="szabKezi['elozo_evi']" [placeholder]="szabadsag.elozo_auto"></td>
                <td class="num"><input type="number" step="0.5" min="0" [(ngModel)]="szabKezi[s.fajta]" [placeholder]="s.auto"></td>
                <td class="num">{{ s.felh | number:'1.0-1' }}</td>
                <td class="num" [class.neg]="s.kiadhato < 0">{{ s.kiadhato | number:'1.0-1' }}</td>
                <td class="num">{{ s.ossz | number:'1.0-1' }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr><td>Fizetett szabadság összesen (nap)</td><td class="num">{{ szabadsag.osszesen.elozo | number:'1.0-1' }}</td><td class="num">{{ szabadsag.osszesen.adott | number:'1.0-1' }}</td>
                <td class="num">{{ szabadsag.osszesen.felh | number:'1.0-1' }}</td><td class="num">{{ szabadsag.osszesen.kiadhato | number:'1.0-1' }}</td><td class="num">{{ szabadsag.osszesen.ossz | number:'1.0-1' }}</td></tr>
              <tr><td>Fizetett szabadság összesen (óra)</td><td colspan="4"></td><td class="num">{{ szabadsag.osszesen.orak | number:'1.0-1' }}</td></tr>
            </tfoot>
          </table>
        </div>
        <div class="tabla-wrap" style="margin-top:8px">
          <table class="n-racs alk-szab">
            <thead><tr><th>Betegszabadság</th><th class="num">Keret (nap)</th><th class="num">Felhasznált</th><th class="num">Maradt</th><th class="num">Keret (óra)</th></tr></thead>
            <tbody><tr>
              <td>Betegszabadság (Mt. 126. §)</td>
              <td class="num"><input type="number" step="0.5" min="0" [(ngModel)]="szabKezi['beteg']" [placeholder]="szabadsag.beteg.auto"></td>
              <td class="num">{{ szabadsag.beteg.felh | number:'1.0-1' }}</td>
              <td class="num" [class.neg]="szabadsag.beteg.maradt < 0">{{ szabadsag.beteg.maradt | number:'1.0-1' }}</td>
              <td class="num">{{ szabadsag.beteg.orak | number:'1.0-1' }}</td>
            </tr></tbody>
          </table>
        </div>
        <label class="kv-mezo" style="margin-top:8px"><span>Megjegyzés</span><input [(ngModel)]="szabKezi['megjegyzes']" maxlength="255" placeholder="pl. apai szabadság a születés miatt"></label>
        <p class="halvany" *ngFor="let f of szabadsag.figyelmeztetesek">⚠ {{ f }}</p>
      </ng-container>
      <ng-template #nincsSzab><p class="halvany">Az évben nincs munkaviszonya – szabadság nem jár (megbízásnál, társas vállalkozónál nincs).</p></ng-template>
    </div>

    <div class="n-panel">
      <div class="alk-panel-fej"><div class="n-panel-cim">Eltartottak · {{ eltartottak.length }} eltartott, {{ kedvezmenyezettSzam }} kedvezményezett</div>
        <button type="button" class="ov-gomb" (click)="ujElt()"><ion-icon name="add"></ion-icon>Új eltartott</button></div>
      <p class="halvany alk-sugo">A családi kedvezmény ebből számolódik (sáv az eltartottak száma szerint), és a bevallás M-lapjához is ez kell.</p>
      <table class="n-racs" *ngIf="eltartottak.length">
        <thead><tr><th>Név</th><th>Jogcím</th><th>Adóazonosító</th><th>Született</th><th></th></tr></thead>
        <tbody>
          <tr *ngFor="let e of eltartottak">
            <td><b>{{ e.nev }}</b></td><td>{{ cimke(opt.eltartottJogcim, e.jogcim) }}</td><td>{{ e.adoazonosito || '—' }}</td>
            <td>{{ e.szul_ido ? (e.szul_ido | date:'yyyy.MM.dd') : '—' }}</td>
            <td class="ber-muv"><button type="button" class="kv-mini" (click)="szerkElt(e)"><ion-icon name="create-outline"></ion-icon></button>
              <button type="button" class="kv-torol" (click)="torolElt(e)"><ion-icon name="trash-outline"></ion-icon></button></td>
          </tr>
        </tbody>
      </table>
    </div>

    <!--  A letiltásoknak saját képernyője van (Bér → Letiltások): egy végrehajtási ügy több
          tételből áll, tételenként más kedvezményezettel és bankszámlával, kielégítési sorrenddel
          és havi kimutatással – ez itt, az adatlap egy paneljében nem fért volna el. -->
    <div class="n-panel">
      <div class="alk-panel-fej"><div class="n-panel-cim">Letiltások</div>
        <button type="button" class="ov-gomb" (click)="letiltasokra()"><ion-icon name="open-outline"></ion-icon>Megnyitás</button></div>
      <p class="halvany">A végrehajtási ügyeket – tételekkel, kedvezményezettekkel, kielégítési sorrenddel
        és havi kimutatással – a <b>Letiltások</b> képernyő kezeli.</p>
    </div>

    <app-ber-tetelek-panel [alkalmazott]="kivalasztott"></app-ber-tetelek-panel>
  </div>
  <div class="ures alk-reszlet" *ngIf="!kivalasztott && alkalmazottak.length"><ion-icon name="person-outline"></ion-icon>Válassz alkalmazottat a listából.</div>
</div>

<!-- Alkalmazott -->
<ion-modal #alkModal cssClass="ber-urlap-modal" (didDismiss)="zarEngedi('zarAlk')">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>{{ szerk?.id ? 'Alkalmazott' : 'Új alkalmazott' }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="alkModal.dismiss()">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <div class="nk-torzs">
      <div class="nk-form" *ngIf="szerk">
        <app-szerk-zar-sav [zar]="zarAlk"></app-szerk-zar-sav>
        <label class="kv-mezo"><span>Törzsszám</span><input type="text" [(ngModel)]="szerk.torzsszam"></label>
        <label class="kv-mezo"><span>Név *</span><input type="text" [(ngModel)]="szerk.nev"></label>
        <label class="kv-mezo"><span>Születési név</span><input type="text" [(ngModel)]="szerk.szuletesi_nev"></label>
        <label class="kv-mezo"><span>Anyja neve</span><input type="text" [(ngModel)]="szerk.anyja_neve"></label>
        <label class="kv-mezo"><span>Születési hely</span><input type="text" [(ngModel)]="szerk.szul_hely"></label>
        <label class="kv-mezo"><span>Születési idő</span><input type="date" [(ngModel)]="szerk.szul_ido"></label>
        <label class="kv-mezo"><span>Neme</span><select [(ngModel)]="szerk.neme"><option *ngFor="let n of opt.neme" [ngValue]="n.value">{{ n.label }}</option></select></label>
        <label class="kv-mezo"><span>Adóazonosító jel</span><input type="text" [(ngModel)]="szerk.adoazonosito"></label>
        <label class="kv-mezo"><span>TAJ szám</span><input type="text" [(ngModel)]="szerk.taj"></label>
        <label class="kv-mezo"><span>Irányítószám</span><input type="text" [(ngModel)]="szerk.irsz"></label>
        <label class="kv-mezo"><span>Település</span><input type="text" [(ngModel)]="szerk.telepules"></label>
        <label class="kv-mezo"><span>Cím</span><input type="text" [(ngModel)]="szerk.cim"></label>
        <label class="kv-mezo"><span>Bankszámla</span><input type="text" [(ngModel)]="szerk.bankszamla"></label>
        <div class="nk-kapcs">
          <label><input type="checkbox" [(ngModel)]="szerk.nyugdijas"> Nyugdíjas</label>
          <label><input type="checkbox" [(ngModel)]="szerk.inaktiv"> Inaktív</label>
        </div>
        <div class="nk-lab"><button type="button" class="ov-gomb fo" (click)="mentAlk()" [disabled]="zarAlk && !zarAlk.irhato"><ion-icon name="save-outline"></ion-icon>Mentés</button></div>
      </div>
    </div>
  </ng-template>
</ion-modal>

<!-- Jogviszony -->
<ion-modal #jvModal cssClass="ber-urlap-modal" (didDismiss)="zarEngedi('zarJv')">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>{{ jvSzerk?.id ? 'Jogviszony' : 'Új jogviszony' }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="jvModal.dismiss()">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <div class="nk-torzs">
      <div class="nk-form" *ngIf="jvSzerk">
        <app-szerk-zar-sav [zar]="zarJv"></app-szerk-zar-sav>
        <label class="kv-mezo"><span>Jogviszony típusa</span>
          <select [(ngModel)]="jvSzerk.jogviszony_tipus" (ngModelChange)="jvTipusValt($event)"><option *ngFor="let t of opt.jogviszonyTipus" [ngValue]="t.value">{{ t.label }}</option></select></label>
        <label class="kv-mezo" *ngIf="jvSzerk.jogviszony_tipus === 'egyeni_vallalkozo' || jvSzerk.jogviszony_tipus === 'tarsas_vallalkozo'"><span>Biztosítási jelleg</span>
          <select [(ngModel)]="jvSzerk.biztositasi_jelleg"><option *ngFor="let t of opt.biztositasiJelleg" [ngValue]="t.value">{{ t.label }}</option></select></label>
        <label class="kv-mezo" *ngIf="jvSzerk.jogviszony_tipus === 'egyeni_vallalkozo'"><span>Költséghányad</span>
          <select [(ngModel)]="jvSzerk.atalany_koltseghanyad"><option *ngFor="let k of opt.koltseghanyad" [ngValue]="k.value">{{ k.label }}</option></select></label>
        <p class="halvany" style="margin:0" *ngIf="jvSzerk.jogviszony_tipus === 'egyeni_vallalkozo'">
          Átalányadós egyéni vállalkozó: nincs fix alapbér – a negyedéves elszámolás a bevétel alapján a <b>Számfejtés → Átalányadós</b> képernyőn, a fenti költséghányaddal.</p>
        <!-- MEGBÍZÁS: költséghányad (Szja tv. 17. §) és tartós megbízás (Tbj. 6. § (1) l) – ber.js berSzamol 1/a, ber-megbizas.js -->
        <ng-container *ngIf="jvSzerk.jogviszony_tipus === 'megbizas'">
          <label class="kv-mezo"><span>Költséghányad (%)</span><input type="number" min="0" max="100" step="1" [(ngModel)]="jvSzerk.megbizas_koltseghanyad" placeholder="10"></label>
          <div class="nk-kapcs"><label><input type="checkbox" [(ngModel)]="jvSzerk.tartos_megbizas"> Tartós megbízási jogviszony (mindig biztosított, 08E kód 1115)</label></div>
          <p class="halvany" style="margin:0" *ngIf="!jvSzerk.tartos_megbizas">
            A jövedelem a díj {{ 100 - (+jvSzerk.megbizas_koltseghanyad || 0) }}%-a (nyilatkozat nélkül 10% a költséghányad). A megbízott abban a hónapban biztosított, amikor ez a jövedelem
            eléri a minimálbér 30%-át – tört hónapban naptári naponként annak harmincadát. Ilyenkor a számfejtés TB-járulékot von, és 08E-teendőt vesz fel.</p>
          <p class="halvany" style="margin:0" *ngIf="jvSzerk.tartos_megbizas">
            Tartós megbízás: minden hónapban biztosított. A 08E-n a jogviszony kezdetével (a munkavégzés előtt) és végével kell be- és kijelenteni.</p>
        </ng-container>
        <label class="kv-mezo"><span>Munkakör</span><input type="text" [(ngModel)]="jvSzerk.munkakor"></label>
        <label class="kv-mezo" *ngIf="munkaszamok.length"><span>Munkaszám</span>
          <select [(ngModel)]="jvSzerk.munkaszam_id"><option [ngValue]="null">—</option><option *ngFor="let m of munkaszamok" [ngValue]="m.id">{{ m.kod }} – {{ m.nev }}</option></select></label>
        <label class="kv-mezo"><span>FEOR</span><input type="text" [ngModel]="jvSzerk.feor" (ngModelChange)="feorKeres($event)" placeholder="kód vagy foglalkozás (pl. 2611, ügyvéd)"></label>
        <div class="feor-talalat" *ngIf="feorTalalatok.length">
          <button type="button" *ngFor="let f of feorTalalatok" (click)="feorValaszt(f)"><b>{{ f.kod }}</b> — {{ f.nev }}</button>
        </div>
        <p class="halvany" style="margin:0" *ngIf="jvSzerk.feor_nev">{{ jvSzerk.feor }} – {{ jvSzerk.feor_nev }}</p>
        <label class="kv-mezo"><span>Belépés</span><input type="date" [(ngModel)]="jvSzerk.kezdet"></label>
        <label class="kv-mezo"><span>Kilépés</span><input type="date" [(ngModel)]="jvSzerk.veg"></label>
        <label class="kv-mezo" *ngIf="jvSzerk.jogviszony_tipus !== 'egyeni_vallalkozo'"><span>Bér típusa</span>
          <select [(ngModel)]="jvSzerk.ber_tipus"><option *ngFor="let t of opt.berTipus" [ngValue]="t.value">{{ t.label }}</option></select></label>
        <label class="kv-mezo" *ngIf="jvSzerk.jogviszony_tipus !== 'egyeni_vallalkozo'"><span>Alapbér (Ft) *</span><input type="number" [(ngModel)]="jvSzerk.alapber" placeholder="havibér vagy órabér"></label>
        <label class="kv-mezo"><span>Heti óraszám</span><input type="number" min="0" [(ngModel)]="jvSzerk.heti_oraszam" [disabled]="jvSzerk.munkarend === 'nincs'"></label>
        <label class="kv-mezo"><span>Munkarend</span>
          <select [(ngModel)]="jvSzerk.munkarend" (ngModelChange)="munkarendValt($event)"><option *ngFor="let t of opt.munkarend" [ngValue]="t.value">{{ t.label }}</option></select></label>
        <div class="nk-kapcs">
          <label><input type="checkbox" [(ngModel)]="jvSzerk.garantalt"> Garantált bérminimumos</label>
          <label><input type="checkbox" [(ngModel)]="jvSzerk.biztositott"> Biztosított</label>
          <label><input type="checkbox" [(ngModel)]="jvSzerk.aktiv"> Aktív</label>
        </div>
        <!-- EKHO (2005. évi CXX. tv.) – a munkavállaló írásbeli nyilatkozata alapján (ber.js berSzamol 1/b) -->
        <ng-container *ngIf="jvSzerk.jogviszony_tipus !== 'egyeni_vallalkozo'">
          <div class="nk-kapcs"><label><input type="checkbox" [(ngModel)]="jvSzerk.ekho"> EKHO-nyilatkozatot tett (egyszerűsített közteherviselési hozzájárulás)</label></div>
          <ng-container *ngIf="jvSzerk.ekho">
            <label class="kv-mezo"><span>EKHO kulcsa</span>
              <select [(ngModel)]="jvSzerk.ekho_kulcs"><option [ngValue]="null">15% (9,5% SZJA + 5,5% TB-járulék)</option><option ngValue="egt">9,5% – más EGT-államban biztosított</option></select></label>
            <label class="kv-mezo"><span>Értékhatár</span>
              <select [(ngModel)]="jvSzerk.ekho_ertekhatar"><option [ngValue]="1">60 millió Ft (általános)</option><option [ngValue]="2">250 millió Ft (edző, sportszövetség, sportfióktelep munkavállalója)</option><option [ngValue]="3">500 millió Ft (hivatásos sportoló)</option></select></label>
            <div class="nk-kapcs"><label><input type="checkbox" [(ngModel)]="jvSzerk.ekho_minimalber_kivetel"> A minimálbérnyi általános szabály szerinti jövedelme máshol / más jogviszonyban megvan (Ekho tv. 3. § (7) b)–c))</label></div>
            <p class="halvany" style="margin:0">Munkaviszonyban a havi bérből csak a minimálbér feletti rész EKHO-s; a minimálbérig tartó rész a szokásos SZJA-val, járulékkal, szochóval (és a kedvezményekkel) adózik.
              Saját jogú nyugdíjasnál (Alkalmazotti törzs) 9,5%, minimálbér-rész nélkül. A FEOR a 3. § (3) szerinti foglalkozás legyen; az éves értékhatárig számol, utána általános szabály szerint.</p>
          </ng-container>
        </ng-container>
        <div class="nk-lab"><button type="button" class="ov-gomb fo" (click)="mentJv()" [disabled]="zarJv && !zarJv.irhato"><ion-icon name="save-outline"></ion-icon>Mentés</button></div>
      </div>
    </div>
  </ng-template>
</ion-modal>

<!-- Kedvezmény -->
<ion-modal #szochoModal cssClass="ber-urlap-modal" (didDismiss)="zarEngedi('zarSzocho')">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>Szocho-kedvezmény</ion-title>
      <ion-buttons slot="end"><ion-button (click)="szochoModal.dismiss()">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <div class="nk-torzs">
      <div class="nk-form" *ngIf="szochoSzerk">
        <app-szerk-zar-sav [zar]="zarSzocho"></app-szerk-zar-sav>
        <label class="kv-mezo"><span>Jogcím</span>
          <select [(ngModel)]="szochoSzerk.tipus" (ngModelChange)="szochoTipusValt()">
            <option *ngFor="let t of opt.szochoKedvezmenyTipus" [ngValue]="t.value">{{ t.label }}</option></select></label>
        <label class="kv-mezo"><span>Alapkorlát</span>
          <select [(ngModel)]="szochoSzerk.alap_korlat">
            <option *ngFor="let t of opt.szochoAlapKorlat" [ngValue]="t.value">{{ t.label }}</option></select></label>
        <label class="kv-mezo" *ngIf="szochoSzerk.alap_korlat === 'osszeg'"><span>Havi felső összeg (Ft)</span>
          <input type="number" [(ngModel)]="szochoSzerk.korlat_osszeg"></label>
        <label class="kv-mezo"><span>Az adó hány %-a</span><input type="number" min="0" max="100" [(ngModel)]="szochoSzerk.szazalek"></label>
        <label class="kv-mezo"><span>Érvényes-tól</span><input type="date" [(ngModel)]="szochoSzerk.ervenyes_tol"></label>
        <label class="kv-mezo"><span>Érvényes-ig</span><input type="date" [(ngModel)]="szochoSzerk.ervenyes_ig"></label>
        <label class="kv-mezo"><span>Megjegyzés</span><input type="text" [(ngModel)]="szochoSzerk.megjegyzes"></label>
        <p class="halvany" style="font-size:.8rem;margin:2px 0 0">
          Munkaerőpiacra lépőnél az első év a minimálbérig 100%, az azt követő fél év a minimálbér feléig –
          ezt két időszakként vedd fel. Megváltozott munkaképességűnél a minimálbér kétszereséig jár.
        </p>
        <div class="nk-lab"><button type="button" class="ov-gomb fo" (click)="mentSzocho()" [disabled]="zarSzocho && !zarSzocho.irhato"><ion-icon name="save-outline"></ion-icon>Mentés</button></div>
      </div>
    </div>
  </ng-template>
</ion-modal>

<ion-modal #kedvModal cssClass="ber-urlap-modal" (didDismiss)="zarEngedi('zarKedv')">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>Kedvezmény</ion-title>
      <ion-buttons slot="end"><ion-button (click)="kedvModal.dismiss()">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <div class="nk-torzs">
      <div class="nk-form" *ngIf="kedvSzerk">
        <app-szerk-zar-sav [zar]="zarKedv"></app-szerk-zar-sav>
        <label class="kv-mezo"><span>Típus</span>
          <select [(ngModel)]="kedvSzerk.tipus"><option *ngFor="let t of opt.kedvezmenyTipus" [ngValue]="t.value">{{ t.label }}</option></select></label>
        <ng-container *ngIf="kedvSzerk.tipus === 'csaladi'">
          <p class="halvany" style="margin:0">Ha vannak rögzített eltartottak, a darabszám onnan jön (az alábbi mezők csak akkor számítanak, ha nincs eltartott felvéve).</p>
          <label class="kv-mezo"><span>Eltartottak száma</span><input type="number" [(ngModel)]="kedvSzerk.eltartottak"></label>
          <label class="kv-mezo"><span>Kedvezményezettek</span><input type="number" [(ngModel)]="kedvSzerk.kedvezmenyezett"></label>
          <label class="kv-mezo"><span>Igénybevett hányad (%)</span><input type="number" [(ngModel)]="kedvSzerk.megoszt_szazalek"></label>
        </ng-container>
        <label class="kv-mezo"><span>Érvényes-tól</span><input type="date" [(ngModel)]="kedvSzerk.ervenyes_tol"></label>
        <label class="kv-mezo"><span>Érvényes-ig</span><input type="date" [(ngModel)]="kedvSzerk.ervenyes_ig"></label>
        <div class="nk-lab"><button type="button" class="ov-gomb fo" (click)="mentKedv()" [disabled]="zarKedv && !zarKedv.irhato"><ion-icon name="save-outline"></ion-icon>Mentés</button></div>
      </div>
    </div>
  </ng-template>
</ion-modal>

<!-- Eltartott -->
<ion-modal #eltModal cssClass="ber-urlap-modal" (didDismiss)="zarEngedi('zarElt')">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>{{ eltSzerk?.id ? 'Eltartott' : 'Új eltartott' }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="eltModal.dismiss()">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <div class="nk-torzs">
      <div class="nk-form" *ngIf="eltSzerk">
        <app-szerk-zar-sav [zar]="zarElt"></app-szerk-zar-sav>
        <label class="kv-mezo"><span>Név *</span><input type="text" [(ngModel)]="eltSzerk.nev"></label>
        <label class="kv-mezo"><span>Adóazonosító jel</span><input type="text" [(ngModel)]="eltSzerk.adoazonosito"></label>
        <label class="kv-mezo"><span>Születési idő</span><input type="date" [(ngModel)]="eltSzerk.szul_ido"></label>
        <label class="kv-mezo"><span>Jogcím</span>
          <select [(ngModel)]="eltSzerk.jogcim"><option *ngFor="let j of opt.eltartottJogcim" [ngValue]="j.value">{{ j.label }}</option></select></label>
        <label class="kv-mezo"><span>Érvényes-tól</span><input type="date" [(ngModel)]="eltSzerk.ervenyes_tol"></label>
        <label class="kv-mezo"><span>Érvényes-ig</span><input type="date" [(ngModel)]="eltSzerk.ervenyes_ig"></label>
        <div class="nk-lab"><button type="button" class="ov-gomb fo" (click)="mentElt()" [disabled]="zarElt && !zarElt.irhato"><ion-icon name="save-outline"></ion-icon>Mentés</button></div>
      </div>
    </div>
  </ng-template>
</ion-modal>

<!-- NAV bejelentett foglalkoztatottak -->
<ion-modal #navModal cssClass="ber-urlap-modal ber-szeles-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej">
      <ion-title>NAV bejelentett foglalkoztatottak</ion-title>
      <ion-buttons slot="end"><ion-button (click)="navModal.dismiss()">Bezár</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <div class="nk-torzs">
      <div class="nk-form">
        <p class="halvany" style="margin:0" *ngIf="navUtolsoSzinkron">NAV szinkron ideje: {{ navUtolsoSzinkron }}</p>
        <div class="ures" *ngIf="navBetolt"><ion-spinner name="dots"></ion-spinner></div>
        <div class="ures" *ngIf="!navBetolt && !navBejelentettek.length">
          <ion-icon name="people-outline"></ion-icon>
          Nincs bejelentett foglalkoztatott. A NAPLO <b>Adófolyószámla</b> képernyőjén futtass NAV-szinkront (M2M szükséges).
        </div>
        <div class="tabla-wrap" style="margin:0" *ngIf="navBejelentettek.length">
          <table class="n-racs">
            <thead><tr><th>Név</th><th>FEOR</th><th>Jogviszony</th><th class="num">Óra/hét</th><th>Kezdet</th><th></th></tr></thead>
            <tbody>
              <tr *ngFor="let f of navBejelentettek" [class.rendezett]="f.importalva">
                <td><b>{{ f.nev }}</b></td>
                <td>{{ f.feor ? (f.feor + ' – ' + (f.feor_megnevezes || '')) : '—' }}</td>
                <td>{{ f.jogviszony_megnevezes || '' }}</td>
                <td class="num">{{ f.heti_ora || '' }}</td><td>{{ f.jogviszony_kezdete || '' }}</td>
                <td class="ber-muv"><span class="cimke zold" *ngIf="f.importalva">már felvéve</span>
                  <button type="button" class="ov-gomb" *ngIf="!f.importalva" (click)="importNav(f)"><ion-icon name="download-outline"></ion-icon>Import</button></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </ng-template>
</ion-modal>

<!-- SULINFORM munkatársak -->
<ion-modal #sulModal cssClass="ber-urlap-modal ber-szeles-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej">
      <ion-title>SULINFORM munkatársak{{ sulIntezmeny ? ' – ' + sulIntezmeny : '' }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="sulModal.dismiss()">Bezár</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <div class="nk-torzs">
      <div class="nk-form">
        <p class="halvany" style="margin:0">A kiválasztott munkatársak BÉR-alkalmazottak lesznek (vagy a már felvett, azonos adóazonosítójú/nevű alkalmazotthoz kötődnek).
          Az összekötött alkalmazottak jelenléte és szabadsága a Béradatoknál a SULINFORM-ból vehető át.</p>
        <div class="ures" *ngIf="sulBetolt"><ion-spinner name="dots"></ion-spinner></div>
        <div class="tabla-wrap" style="margin:0" *ngIf="!sulBetolt && sulLista.length">
          <table class="n-racs">
            <thead><tr><th style="width:34px"></th><th>Név</th><th>Adóazonosító</th><th>Munkakör</th><th class="num">Alapbér</th><th>BÉR-alkalmazott</th></tr></thead>
            <tbody>
              <tr *ngFor="let m of sulLista" [class.rendezett]="m.alkalmazott_id">
                <td><input type="checkbox" [(ngModel)]="sulValasztott[m.adid]" [disabled]="!!m.alkalmazott_id"></td>
                <td><b>{{ m.nev }}</b></td><td>{{ m.adoazonosito || '—' }}</td><td>{{ m.munkakor || '—' }}</td>
                <td class="num">{{ m.alapber ? (m.alapber | number:'1.0-0') : '—' }}</td>
                <td>
                  <span class="cimke zold" *ngIf="m.alkalmazott_id">összekötve</span>
                  <span class="cimke sarga" *ngIf="!m.alkalmazott_id && m.jelolt_id" [title]="'Összekötés a meglévő alkalmazottal: ' + m.jelolt_nev">párosul: {{ m.jelolt_nev }}</span>
                  <span class="cimke" *ngIf="!m.alkalmazott_id && !m.jelolt_id">új alkalmazott</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="nk-kapcs" *ngIf="!sulBetolt && sulLista.length">
          <label><input type="checkbox" [(ngModel)]="sulJogviszony"> Munkaviszony létrehozása az új alkalmazottaknak (alapbér és részmunkaidő a SULINFORM-ból – a bérlapon ellenőrizd)</label>
        </div>
        <div class="nk-lab" *ngIf="!sulBetolt && sulLista.length">
          <button type="button" class="ov-gomb" (click)="sulMindet(true)"><ion-icon name="checkmark-done-outline"></ion-icon>Mind</button>
          <button type="button" class="ov-gomb" (click)="sulMindet(false)"><ion-icon name="close-outline"></ion-icon>Egyik sem</button>
          <button type="button" class="ov-gomb fo" [disabled]="!sulKijelolt.length" (click)="sulImport()"><ion-icon name="download-outline"></ion-icon>Kijelöltek importálása ({{ sulKijelolt.length }})</button>
        </div>
      </div>
    </div>
  </ng-template>
</ion-modal>
